// src/api/api.js
import axios from "axios";
import { getCache, setCache } from "./apiCache";
export const BE_URL = process.env.REACT_APP_BE_URL;
export const ASSET_URL = process.env.REACT_APP_BE_URL2 || BE_URL?.replace(/\/api\/?$/, '');

export const api = axios.create({ baseURL: BE_URL, withCredentials: true });

// Add custom cached GET method
api.getWithCache = async (url, config = {}, expiryMs) => {
  const cacheKey = url + (config.params ? JSON.stringify(config.params) : "");
  const cachedData = getCache(cacheKey);
  if (cachedData) return { data: cachedData, fromCache: true };

  const response = await api.get(url, config);
  setCache(cacheKey, response.data, expiryMs);
  return response;
};

// Request Interceptor: Her isteğe tokenı ekle
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token") || sessionStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // Eğer hata 401 ise ve daha önce yenileme denenmemişse
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      try {
        // Backend'deki /refresh endpoint'ine git (Cookie'deki refreshToken'ı otomatik gönderir)
        const res = await axios.post(`${BE_URL}/auth/refresh`, {}, { withCredentials: true });
        const { accessToken } = res.data;

        // Eski token neredeyse yenisini de oraya koy
        if (localStorage.getItem("token")) {
          localStorage.setItem("token", accessToken);
        } else {
          sessionStorage.setItem("token", accessToken);
        }

        originalRequest.headers['Authorization'] = `Bearer ${accessToken}`;
        return api(originalRequest); // Başarısız olan isteği yeni tokenla tekrar at
      } catch (refreshError) {
        // Refresh de patlarsa (süresi dolmuşsa) logout yap
        localStorage.removeItem("token");
        sessionStorage.removeItem("token");
        // Sadece ana sayfaya veya logine yönlendir, reload etme ki kullanıcı ne olduğunu anlasın (isteğe bağlı)
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);